<form [formGroup]="campagneForm" (ngSubmit)="onSubmit()">
  @if (errors) {
    <div class="alert alert-danger">{{ errors }}</div>
  }
  <!-- Champ pour le nom de la campagne -->
  <div class="form-group">
    <label for="nom">Nom de la campagne</label>
    <input formControlName="nom" id="nom" class="form-control">
  </div>


  <div class="form-group">
    <label for="personnagesJoueurs">Personnages Joueurs</label>
    <input type="text" class="form-control" id="personnagesJoueurs"
      [(ngModel)]="searchPJ"
      (input)="onSearchPJ($event)" placeholder="Rechercher un personnage joueur...">

      @if (filteredPJ.length > 0) {
        <ul class="autocomplete-list">
          @for (pj of filteredPJ; track pj) {
            <li (click)="addPJ(pj)">
              {{ pj.name }}
            </li>
          }
        </ul>
      }

      <!-- Barre des personnages joueurs sélectionnés -->
      <div class="selected-list">
        @for (pj of selectedPJs; track pj) {
          <span class="badge badge-pill badge-primary">
            {{ pj.name }} <button type="button" (click)="removePJ(pj)">×</button>
          </span>
        }
      </div>
    </div>

    <!-- Autocomplétion pour les PNJs -->
    <div class="form-group">
      <label for="pnjs">PNJs</label>
      <input type="text" class="form-control" id="pnjs"
        [(ngModel)]="searchPNJ"
        (input)="onSearchPNJ($event)" placeholder="Rechercher un PNJ...">

        @if (filteredPNJ.length > 0) {
          <ul class="autocomplete-list">
            @for (pnj of filteredPNJ; track pnj) {
              <li (click)="addPNJ(pnj)">
                {{ pnj.name }}
              </li>
            }
          </ul>
        }

        <!-- Barre des PNJs sélectionnés -->
        <div class="selected-list">
          @for (pnj of selectedPNJs; track pnj) {
            <span class="badge badge-pill badge-danger">
              {{ pnj.name }} <button type="button" (click)="removePNJ(pnj)">×</button>
            </span>
          }
        </div>
      </div>

      <!-- Speech de la campagne -->
      <div class="form-group">
        <label for="speech">Speech</label>
        <quill-editor formControlName="speech" id="speech" name="speech"></quill-editor>
      </div>

      <button type="submit" class="btn btn-primary">Enregistrer</button>
    </form>
